import React from "react";
import { connect } from "react-redux";
import {IconButton} from "@material-ui/core";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";
import MainHelper, {apiCall} from "../../helpers/MainHelper";

class CollectionsTable extends React.Component {
  handleDelete = async (collectionId,receiveID) => {
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall('business/receivable/collection/delete/'+collectionId+'/'+receiveID,'delete');
          await this.props.fetchReceive();
          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
            'Silindi!',
            'Tahsilat başarıyla silindi.',
            'success'
        );
      } else {
        Swal.fire(
            'Hata!',
            'Silme işlemi başarısız oldu.',
            'error'
        );
      }
    }
  }
  render() {
    const { bodyData } = this.props;
    return (

      <div className="table-responsive">
        <table className="table m-b-0 table-hover">
          <thead className="thead-light">
          <tr>
            <th>Ödenen Tutar</th>
            <th>Kalan Tutar</th>
            <th>Tahsilat Tarihi</th>
            <th>Ödeme Tipi</th>
            <th>Banka</th>
            <th>Açıklama</th>
            <th>İşlemler</th>

          </tr>
          </thead>
          <tbody>
            {bodyData.map((data, i) => {
              return (
                  <tr key={"dihf" + i}>
                    <td className="project-title">
                      {data.amount}
                    </td>
                    <td className="project-title">
                      {data.remaining_amount}
                    </td>
                    <td>
                      {MainHelper.dateFormat(data.collection_date).split(' 0')[0]}
                    </td>
                    <td>
                      {data.payment_type}
                    </td>
                    <td>
                      {data.bank?.name}
                    </td>
                    <td>
                      {data.description}
                    </td>
                    <td>
                      <IconButton className="btn btn-outline-secondary"
                                  onClick={() => this.handleDelete(data.id, data.receivable_id)}
                                  style={{cursor: 'pointer', marginLeft: -15}}>
                        <button type="button" className="btn btn-outline-danger btn-sm"><i className="icon-trash"></i>
                        </button>
                      </IconButton>
                    </td>
                  </tr>
              );
            })}
          </tbody>
        </table>
      </div>

    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(CollectionsTable);
